export default __webpack_public_path__ + "static/media/tarek.bfcbf186.jpeg";